import {Location} from '@angular/common';
import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

@Injectable()
export class UserInfoService {
  userInfo: any = {};

  static includeInArray (arr, value): boolean {
    let isInclued = false;
    for (const v of arr) {
      if (v === value) {
        isInclued = true;
      }
    }

    return isInclued;
  }

  constructor (private location: Location) {
    this.load();
  }

  load () {
    let lastUserInfo = {timestamp: 0};
    let appArray = [];
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    for (const n in this.userInfo) {
      if (!isNullOrUndefined(n)) {
        if (this.userInfo[n].timestamp > lastUserInfo.timestamp) {
          lastUserInfo = this.userInfo[n];
        }
        appArray = this.userInfo[n].app ? [...appArray, ...this.userInfo[n].app] : appArray;
      }
    }
    this.userInfo = Object.assign(this.userInfo, lastUserInfo);
    this.userInfo.app = appArray;
    this.userInfo.app.push('demo');
  }

  save (info, role) {
    info.timestamp = +(new Date());
    info = Object.assign({authority: role}, info);
    this.load();
    for (const n in this.userInfo) {
      if (n && this.userInfo[n].phone !== undefined && this.userInfo[n].phone !== info.phone) {
        this.userInfo = {};
        localStorage.clear();
        break;
      }
    }
    this.userInfo[role + 'Info'] = info;

    localStorage.setItem('userInfo', JSON.stringify(this.userInfo));
    this.load();
  }

  private getRole (): { name: string, token: string } {
    const userInfo = JSON.parse(localStorage['userInfo']);
    const roles = ['admin', 'user', 'nurse'];
    let token = '';
    let role = 'other';
    for (const r of roles) {
      if (userInfo[r + 'Info'] && (this.location.path() as string).indexOf('/' + r + '/') >= 0) {
        token = userInfo[r + 'Info'].token;
        role = r;
        break;
      }
    }
    return {name: role, token: token};
  }


  check (path, operate): boolean {
    const userInfo = JSON.parse(localStorage['userInfo']);
    const info = userInfo[this.getRole().name + 'Info'];
    let roles = [];

    for (const app of info.app) {
      if (app.appPath === path) {
        roles = app.role;
      }
    }

    for (const role of roles) {
      if (role.scope.isYHJ && UserInfoService.includeInArray(role.permission, operate)) {
        return true;
      } else if (!role.scope.isYHJ && UserInfoService.includeInArray(role.permission, operate)) {
        return true;
      }
    }
    return false;
  }

  private checkWithAppAndRole (appPath: string, roleName: string): boolean {
    let findedApp, findedAppSubRole;
    findedApp = this.userInfo.app.find(app =>
      app.appPath === appPath);
    if (!findedApp) {
      return false;
    } else {
      findedAppSubRole = findedApp.role.find(role =>
        role.roleName === roleName);
      if (!findedAppSubRole) {
        return false;
      }
    }
    return true;
  }

  checkWithAppAndRoleArray (appPath: string, roleNameArray: Array<string>): boolean {
    for (const roleName of roleNameArray) {
      if (this.checkWithAppAndRole(appPath, roleName)) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/user-info/user-info.service.ts